import { CommonLabels } from '../../assets/labels/labels';
import './PoweredBy.scss';
import { HelperWebView } from "../../core/services/helper/helper.service";
import appConfig from '../../core/appConfig';
import axios from "axios";



interface PoweredByProps {
  styleClass?: string;
  isTop?: boolean; 
}

const pushEventAnalytics = async () => {
  try {
    await axios.get(`${appConfig.BASE_URL}/analytics?key=click&value=keymaster`, {
    });
  } catch (error) {
    // Handle the error, e.g., logging it or returning an empty array
    console.error("Error:", error);
  }
}


const PoweredBy = (props: PoweredByProps) => {
  const { styleClass } = props; 

  const renderText = () => {
    if (HelperWebView.isIOSWebview()) {
      return (
        <span> Powered by <span className='product-name branding'> keymaster </span> </span>
      );
    }
    return (
      <div>
        {`${CommonLabels.poweredBy} `}
        <span className='product-name'>
          {' '}www.<span className='branding'>keymaster</span>.pt
        </span>
      </div>
    );
  }

 if (HelperWebView.isIOSWebview()) {
    return (
      <div className={`powered-by-container ${styleClass ? styleClass : ''}`}
          onClick={pushEventAnalytics}>
          {renderText()}
      </div>
    );
  }

  return (
    <a
      className={`powered-by-container ${styleClass ? styleClass : ""}`}
      href="https://www.keymaster.pt/"
      target={"_blanK"}
      rel="noopener noreferrer"
      role={"button"}
      onClick={pushEventAnalytics}
    >
      {renderText()}
    </a>
  );

}

export default PoweredBy;
